import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { PlanOptionComponent } from "./components/plan-option/plan-option";
import { TouItemComponent } from "./components/tou-item/tou-item";
import { PlanScratchFilterPipe } from "./pipes/plan-list-filter/plan-list-filter";
import { ImgService } from "./services/img.service";
import { OfflineService } from "./services/offline.service";
import { SportAlgoUtils } from "./services/sport.algo";
import { TournamentService } from "./services/tournament.service";
const routes: Routes = [
    { path: '', loadChildren: () =>
      import('./pages/gamer-pages.module').then(m => m.GamerPagesModule)
  },
  ];
@NgModule({
    declarations: [
      PlanOptionComponent,
      TouItemComponent,
      PlanScratchFilterPipe
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
      PlanOptionComponent,
      TouItemComponent,
      PlanScratchFilterPipe
    ]
  })
  export class GamerModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }